<script>
  import options from './CardList.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <!-- Backend dev notes: colorthemes set by editor -->
  <section class="be-card-list" :class="colortheme">
    <div class="be-card-list__content-wrapper">
      <h2 class="be-font-heading-2 be-card-list__title">{{title}}</h2>
      
      <template v-if="leader !== null">
        <p class="be-font-paragraph-2 be-card-list__leader">{{ leader }}</p>
      </template>

      <ul class="be-card-list__cards-list-wrapper" 
          :class="{ 'be-card-list__cards-list-wrapper--4-cards' : cardsResult.length > 3 ? true : false }">

          <template v-for="(card, index) in cardsResult" :key="index">  

            <template v-if="typeCard === 'ContentCard'">
              <li>
                <ContentCard :result="card"  :narrowCardPadding="cardsResult.length > 3 ? true : false" />
              </li>
            </template>

            <template v-if="typeCard === 'NavigationCard'">
              <li>
                <NavigationCard :result="card" />
              </li>
            </template>

          </template>
        
      </ul>

    </div>
  </section>
</template>
